import React, { useState } from "react";
import { Stack } from "react-bootstrap";
import { HouseDoor, PersonCircle, Gear, BoxArrowLeft, List, Database } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { IconButton, AddButton } from "../Buttons.tsx";

import { useHomeContext } from "../../views/Home/HomeView.context.tsx";
import {
  DesktopSidebar,
  IconGroup,
  MenuButton,
  MobileOffcanvas,
  MobileOffcanvasBody,
  MobileSidebarWrapper,
} from "./styles.tsx";

const SidebarUI: React.FC = () => {
  const { t } = useTranslation();
  const { openNewProjectModal, setCurrentView, openLogOutModal, canManageCatalog } =
    useHomeContext();
  const [showMenu, setShowMenu] = useState(false);

  const open = () => setShowMenu(true);
  const close = () => setShowMenu(false);

  return (
    <>
      <MobileSidebarWrapper>
        <MenuButton variant="light" onClick={open}>
          <List size={20} />
        </MenuButton>
      </MobileSidebarWrapper>

      {/* Desktop View */}
      <DesktopSidebar xs="auto">
        <Stack className="justify-content-start">
          <AddButton onClick={openNewProjectModal} />

          <IconButton
            icon={<HouseDoor />}
            label={t("sidebar.home")}
            onClick={() => setCurrentView("noProjects")}
          />

          <IconButton
            icon={<PersonCircle />}
            label={t("sidebar.profile")}
            onClick={() => setCurrentView("profile")}
          />

          {canManageCatalog && (
            <IconButton
              icon={<Database />}
              label={t("sidebar.catalog")}
              onClick={() => setCurrentView("catalog")}
            />
          )}
        </Stack>

        <Stack className="justify-content-end mt-auto">
          <IconButton
            icon={<Gear />}
            label={t("sidebar.settings")}
            onClick={() => setCurrentView("settings")}
          />

          <IconButton
            icon={<BoxArrowLeft />}
            label={t("sidebar.logout")}
            onClick={openLogOutModal}
          />
        </Stack>
      </DesktopSidebar>

      {/* Mobile View */}
      <MobileOffcanvas show={showMenu} onHide={close} placement="start">
        <MobileOffcanvasBody>
          <IconGroup>
            <AddButton
              onClick={() => {
                openNewProjectModal();
                close();
              }}
            />

            <IconButton
              icon={<HouseDoor size={18} />}
              label=""
              onClick={() => {
                setCurrentView("noProjects");
                close();
              }}
            />

            <IconButton
              icon={<PersonCircle size={18} />}
              label=""
              onClick={() => {
                setCurrentView("profile");
                close();
              }}
            />

            {canManageCatalog && (
              <IconButton
                icon={<Database size={18} />}
                label=""
                onClick={() => {
                  setCurrentView("catalog");
                  close();
                }}
              />
            )}
          </IconGroup>

          <IconGroup>
            <IconButton
              icon={<Gear size={18} />}
              label=""
              onClick={() => {
                setCurrentView("settings");
                close();
              }}
            />

            <IconButton
              icon={<BoxArrowLeft size={18} />}
              label=""
              onClick={() => {
                openLogOutModal();
                close();
              }}
            />
          </IconGroup>
        </MobileOffcanvasBody>
      </MobileOffcanvas>
    </>
  );
};

export default SidebarUI;
